import zIndex from "@mui/material/styles/zIndex";
import React, { useState } from "react";
import GooglePlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-google-places-autocomplete";

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_API_KEY;

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    height: 40,
    borderRadius: 8,
    border: state.isFocused
      ? "2px solid var(--primary-red-base)"
      : "1px solid rgba(0, 0, 0, 0.23)",
    boxShadow: "none",
    marginBottom: "16px",
    position: "absolute",
    zIndex: 999,
    top: "12px",
    width: "75%",
    left: "12px",
  }),
  input: (provided) => ({
    ...provided,
    padding: 4,
    fontWeight: 600,
    color: "var(--neutral-black)",
    lineHeight: "157%",
    fontSize: "14px",
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 12px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#aaa",
  }),
  option: (base) => ({
    ...base,
    fontWeight: 500,
    color: "var(--neutral-700)",
    lineHeight: "157%",
    fontSize: "12px",
    cursor: "pointer",
  }),
};

function Landmark({ mapToDefaultLocation, onAddressSelect }) {
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [location, setLocation] = useState({ lat: null, lng: null });

  const handleSelect = async (place) => {
    if (!place) return;

    setSelectedPlace(place);
    geocodeByPlaceId(place.value.place_id)
      .then((results) => {
        const geometry = results[0]?.geometry?.location;
        const coords = {
          lat: geometry.lat(),
          lng: geometry?.lng(),
        };
        if (coords) {
          mapToDefaultLocation(coords);
          // Call onAddressSelect with formatted address
          if (onAddressSelect && results[0]?.formatted_address) {
            onAddressSelect(results[0].formatted_address);
          }
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <GooglePlacesAutocomplete
      apiKey={GOOGLE_MAPS_API_KEY}
      selectProps={{
        styles: customStyles,
        placeholder: "Search...",
        onChange: handleSelect,
      }}
    />
  );
}

export default Landmark;
